import { createContext, useContext } from 'react';

export const ToastContext = createContext(null);

export const ToastProvider = ToastContext.Provider;

export const useToastContext = () => useContext(ToastContext);
